import React from "react";
import DashboardLayout from "../../../Layout/DashboardLayout";
import Header from "./components/Header";
import SearchBox from "./components/SearchBox";

type Props = {};

const AssignRoles = (props: Props) => {
  return (
    <DashboardLayout
      title="Admin Management"
      back={false}
      // right={<SearchBox />}
    >
      <Header title="Assign Role" />
      <p>ASSIGN ROLES</p>
    </DashboardLayout>
  );
};

export default AssignRoles;
